export default __webpack_public_path__ + "static/media/affisch_2_a2_ara.38370574.png";